export const BUSINESS = {
  address: "United Kingdom",
  phone: "07304 442195",
  phoneHref: "tel:+447304442195",
  days: "Monday – Friday",
  hours: "7:00am – 6:00pm",
  email: "WilkoTechLTD@outlook.com",
};
